module.exports = __webpack_public_path__ + "static/media/quadrato.553a7034.svg";